module.exports = __webpack_public_path__ + "img/Taurus.5d054c95.png";